<template>
  <d-container
    fluid
    class="main-content-container px-4">
    <!-- Page Header -->
    <d-row
      no-gutters
      class="page-header py-4">
      <d-col
        col
        sm="6"
        class="text-center text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle">Użytkownicy</span>
        <h3 class="page-title">
          <template v-if="isEdit">Edycja użytkownika
            <p
              class="mt-2"
              style="font-weight: 100">{{data.name}}
              <d-badge
                style="font-size: 1rem"
                class="ml-2"
                :theme="data.active === 1 ? 'success' : 'dark'">
                {{data.active === 1 ? 'Aktywny' : 'Nieaktywny'}}
              </d-badge>
            </p>
          </template>
          <template v-else>Dodawanie użytkownika</template>
        </h3>
      </d-col>
      <d-col
        col
        sm="6"
        class="text-right text-sm-right d-flex justify-content-end align-items-end">
        <d-button
          theme="secondary"
          @click.prevent="$router.push('/uzytkownicy')"
          class="mr-1">
          <i class="material-icons">arrow_back</i>
          Wróć do listy
        </d-button>
        <d-button
          theme="success"
          @click.prevent="validateForm">
          Zapisz zmiany
        </d-button>
      </d-col>
    </d-row>
    <!-- Form -->
    <d-form>
      <d-card class="mb-5">
        <d-tabs card>
          <!-- Dane ogólne -->
          <d-tab
            title="Dane ogólne"
            active>
            <h4 class="mb-3 pb-3 border-bottom">
              Dane ogólne
            </h4>

            <validation-observer
              ref="administrator-form"
              tag="form">
              <d-row>
                <d-col
                  cols="6"
                  md="6"
                  lg="8">
                  <div class="form-group">
                    <label for="name">
                      Imię i nazwisko:
                    </label>

                    <validation-provider
                      rules="required"
                      name="name"
                      v-slot="{ errors }">
                      <d-input
                        :state="errors.length ? 'invalid' : null"
                        v-model="data.name" />
                      <div class="invalid-feedback">
                        {{ errors[0] }}
                      </div>
                    </validation-provider>
                  </div>
                </d-col>
                <d-col
                  cols="6"
                  md="6"
                  lg="4">
                  <div class="form-group">
                    <validation-provider
                      rules="required"
                      name="active"
                      v-slot="{ errors }">
                      <label for="active">Aktywny:</label>
                      <div :class="{ 'form-control': true, 'is-select': true, 'is-invalid': errors.length }">
                        <v-select
                          class="user-select-style"
                          :options="statusType"
                          :reduce="type => type.value"
                          v-model="data.active"
                          placeholder="Wybierz status aktywności"
                          label="text"
                          :state="errors.length ? 'invalid' : null">
                        </v-select>
                      </div>
                      <div class="invalid-feedback">
                        {{ errors[0] }}
                      </div>
                    </validation-provider>
                  </div>
                </d-col>
              </d-row>
              <div class="form-group">
                <label for="email">
                  E-mail:
                </label>

                <validation-provider
                  rules="required|email"
                  name="email"
                  v-slot="{ errors }">
                  <form autocomplete="off">
                    <d-input
                      :state="errors.length ? 'invalid' : null"
                      :autocomplete="'off'"
                      type="email"
                      v-model="data.email" />
                    <div class="invalid-feedback">
                      {{ errors[0] }}
                    </div>
                  </form>

                </validation-provider>
              </div>
              <div class="form-group">
                <label for="password">
                  Hasło:
                </label>

                <validation-provider
                  :rules="isEdit ? 'min:6' : 'required|min:6'"
                  name="password"
                  v-slot="{ errors }">
                  <form autocomplete="off">
                    <d-input
                      :autocomplete="'off'"
                      type="password"
                      :state="errors.length ? 'invalid' : null"
                      v-model="data.password" />
                    <div class="invalid-feedback">
                      {{ errors[0] }}
                    </div>
                  </form>

                </validation-provider>
              </div>
            </validation-observer>
            <div
              v-if="!allDataLoaded"
              class="pb-3 pt-3 text-center">
              Trwa ładowanie danych&hellip;
            </div>

            <d-alert
              v-if="load_error"
              show
              theme="warning">
              Wczytywanie danych nie powiodło się. <a
                href="javascript:window.location.reload();"
              class="alert-link">Odśwież stronę</a> aby spróbować ponownie.
            </d-alert>
          </d-tab>
        </d-tabs>
      </d-card>
    </d-form>
  </d-container>
</template>

<script>
import FormUtils from './../../utils/FormUtils.js';

export default {
  name: 'user-form',
  computed: {
    allDataLoaded () {
      return this.loaded && this.loaded_administrators;
    },
    isEdit () {
      return !!this.$route.params.id;
    },
    statusType () {
      return [
        {
          text: 'Tak',
          value: 1
        },
        {
          text: 'Nie',
          value: 0
        },
      ];
    }
  },
  data () {
    return {
      data: {
        id: 0,
        name: '',
        email: '',
        password: '',
        passwordConfirmation: '',
        active: ''
      },
      loaded: false,
      load_error: false,
      loaded_administrators: false,
      administrators: []
    };
  },
  watch: {
    'data.password': function (value) {
      this.data.passwordConfirmation = value;
    }
  },
  mounted () {
    if (this.isEdit) {
      this.loadItemData();
    } else {
      this.loaded = true;
    }

    this.loadAdditionalData();
  },
  methods: {
    loadItemData () {
      FormUtils.loadItemData(this, {
        endpointBase: '/administrators/item/',
        instanceFields: ['id', 'name', 'email', 'active'],
        loadedKey: 'loaded'
      });
    },
    loadAdditionalData () {
      FormUtils.loadAdditionalData(this, {
        endpoint: '/administrators/items',
        params: {
          pagination: false
        },
        outputKey: 'administrators',
        loadedKey: 'loaded_administrators',
        errorKey: 'load_error',
      });
    },
    validateForm () {
      FormUtils.validate(this.$refs['administrator-form'], this.submitForm);
    },
    submitForm () {
      let formDataToSend = this.prepareFormDataToSend();
      let endpointUrl = this.isEdit ? '/administrators/update/' + this.id : '/administrators/store';

      FormUtils.submit(this, {
        endpoint: endpointUrl,
        formData: formDataToSend,
        successTitle: 'Zapisano użytkownika',
        successText: 'Wybrany użytkownik został zapisany',
        errorTitle: 'Wystąpił błąd',
        errorText: 'Modyfikacja użytkownika nie powiodła się. Spróbuj ponownie.',
        successAction: () => {
          this.$router.push('/uzytkownicy');
        }
      });
    },
    prepareFormDataToSend () {
      let formDataToSend = {
        name: this.data.name,
        email: this.data.email,
        active: this.data.active,
        type: 'ADMIN'
      };

      if (this.data.password !== '' && this.data.passwordConfirmation !== '') {
        formDataToSend.password = this.data.password;
        formDataToSend.password_confirmation = this.data.passwordConfirmation;
      }

      return formDataToSend;
    }
  }
};
</script>
<style lang="scss">
  .user-select-style {
    .vs__actions {
      position: absolute;
      margin-left: 90%;
    }
  }
  .input-for-select {
    position: absolute;
    margin-top: -0.4rem;
    background: transparent;
    margin-left: -0.2rem;
    width: 100.6%;
  }
  .user-status-dropdown {
    margin-left: 2rem;
    border-radius: 20px;
    .dropdown-toggle {
      padding: 0.5rem 1.7rem;
    }
    .accept, .blocked {
      min-width: 8rem !important;
    }
  }
  @media only screen and (max-width: 1700px) {
    .user-select-style {
      .vs__actions {
        position: absolute;
        margin-left: 85%;
      }
    }
  }
  @media only screen and (max-width: 1200px) {
    .user-select-style {
      .vs__actions {
        position: absolute;
        margin-left: 80%;
      }
    }
  }
</style>
